//libs
import React, {Component} from 'react';
import {connect} from 'react-redux';
//components
import PageWithSidebar from '../Layouts/PageWithSidebar';
import CreateUserForm from '../UI_Elements/Forms/CreateUserForm';
import CreateGroupForm from '../UI_Elements/Forms/CreateGroupForm';
import CreateCarForm from '../UI_Elements/Forms/CreateCarForm';
import EditLastOnRentDate from '../UI_Elements/Forms/EditLastOnRentDate';
import ListGroups from '../UI_Elements/ListGroups';
import ImportForm from '../UI_Elements/Forms/ImportForm';
import DeleteWheelForm from "../UI_Elements/Forms/DeleteWheelForm";
import UpdateOrderLimit from '../UI_Elements/Forms/UpdateOrderLimit';
//other
import {getGroups} from '../../actions/stations';
import {shouldRefresh, isAdmin} from '../../helpers';



class UsersGroups extends Component {
    constructor(props) {
        super(props);
        if (isAdmin()){
            props.getGroups();
        }
    }

    componentWillReceiveProps(props) {
        if (isAdmin()){
            if (shouldRefresh(props, "stationGroups")) {
                props.getGroups();
            }
        }
    }

    render() {
        return (

            <PageWithSidebar page={"userandgroups"} location={this.props.location}>

                <h1>Användare &amp; grupper</h1>

                <div className="leftbar">
                    <ListGroups/>
                </div>

                <div className="rightbar">
                    <CreateUserForm/>
                    <CreateGroupForm
                        groups={this.props.groups}
                    />
                    <EditLastOnRentDate />
                    <ImportForm />
                    <CreateCarForm />
                    <DeleteWheelForm/>
                    <UpdateOrderLimit/>
                </div>

            </PageWithSidebar>
        );
    }
}


/**
 * Map state to properties
 */
const mapStateToProps = (state) => {
    return {
        groups: state.stations.groups,
        fetch: state.refresh.fetch,
        refresh: state.refresh
    };
};


/**
 * Map actions to properties
 */
const mapDispatchToProps = (dispatch) => {
    return {
        UsersGroups: () => dispatch(UsersGroups()),
        getGroups: () => dispatch(getGroups())
    };
};

/**
 * Export Edit Employee
 */
export default connect(mapStateToProps, mapDispatchToProps)(UsersGroups);


// WEBPACK FOOTER //
// ./src/components/UsersGroups/index.js